module.exports = __webpack_public_path__ + "img/imgImgHome01.e1c743bb.svg";